import { render } from "./pathSetup.vue?vue&type=template&id=9d2bdbfe&scoped=true"
import script from "./pathSetup.vue?vue&type=script&lang=js"
export * from "./pathSetup.vue?vue&type=script&lang=js"

import "./pathSetup.vue?vue&type=style&index=0&id=9d2bdbfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d2bdbfe"]])

export default __exports__